import 'chosen-js';

const Chosen = {

    init(form){
        this.el = form.find('select.chosen');
        if(!this.el.length) return;

        this.el.each((i, el)=>{
            const select = $(el);
            if(!select.is('.search')){
                this.bind(select);
            } else {
                this.bindSearch(select);
            }

        })
    },

    bind(select){
        select.chosen({
            disable_search: true,
            allow_single_deselect: true,
            width: '100%',
            inherit_select_classes: true,
            max_selected_options: 50
        }).bind('chosen:maxselected', function () {
            //  console.log('limit', this, $(this))
        }).change(function() {
            //var totalSelected = $(this).find('option:selected').size();
            // console.log(totalSelected)
        });
    },

    bindSearch(select){
        select.chosen({
            disable_search: false,
            no_results_text: 'Nenašla sa zhoda: ',
            allow_single_deselect: true,
            search_contains: true,
            max_selected_options: 50,
            width: '100%'
        });
    },
}

export default Chosen;